document.addEventListener('DOMContentLoaded', function() {

// ========== Highlight Series in titles ==========
document.querySelectorAll('[data-title]').forEach(function(el){
  el.innerHTML=el.innerHTML.replace(/(\S+\s+Series)/gi,'<span style="color:var(--accent)">$1</span>');
});

/* State management, selColor, togAddon, chgQty, atcClick, confirmAtc — handled by inline script in section */

window.selTrumpet=function(type,el){
  document.querySelectorAll('.trumpet-opt').forEach(function(t){t.classList.remove('active')});
  el.classList.add('active');
};

// ========== Desktop sticky ATC — show when hero section scrolls out of view ==========
(function(){
  var dAtc=document.getElementById('dAtc');
  var hero=document.getElementById('buy');
  if(!dAtc||!hero) return;
  window.addEventListener('scroll',function(){
    var rect=hero.getBoundingClientRect();
    dAtc.classList.toggle('visible', rect.bottom < 0);
  },{passive:true});
})();

// ========== Gallery slider ==========
(function(){
  var track=document.getElementById('galTrack');
  var dotsC=document.getElementById('galDots');
  var thumbsC=document.getElementById('galThumbs');
  if(!track) return;

  var slides=Array.from(track.querySelectorAll('.gallery__slide'));
  var dots=dotsC?Array.from(dotsC.querySelectorAll('.gallery__dot')):[];
  var thumbs=thumbsC?Array.from(thumbsC.querySelectorAll('.gallery__thumb')):[];

  var total=slides.length;
  if(total===0) return;
  var idx=0;

  function galShow(i,animate){
    idx=((i%total)+total)%total;
    track.style.transition=animate?'transform .4s cubic-bezier(.25,.8,.25,1)':'none';
    track.style.transform='translateX('+idx*(-100)+'%)';
    dots.forEach(function(d,j){d.classList.toggle('active',j===idx);});
    thumbs.forEach(function(t,j){t.classList.toggle('active',j===idx);});
  }

  // Bind clicks
  dots.forEach(function(d,i){d.onclick=function(){galShow(i,true);};});
  thumbs.forEach(function(t,i){t.onclick=function(){galShow(i,true);};});

  window.galGo=function(dir){galShow(idx+dir,true);};
  window.galTo=function(i){galShow(i,true);};

  // Init first visible
  galShow(0,false);

  // Touch swipe
  var el=document.getElementById('galSlider');
  if(el){
    var startX=0,dx=0;
    el.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;dx=0;},{passive:true});
    el.addEventListener('touchmove',function(e){dx=e.touches[0].clientX-startX;},{passive:true});
    el.addEventListener('touchend',function(){if(Math.abs(dx)>40){galGo(dx<0?1:-1);}});
  }
})();

// ========== Social video player ==========
window.playSocial=function(card,id){
  var th=card.querySelector('.social-thumb'),fr=card.querySelector('.social-iframe');
  if(!th||!fr) return;
  if(fr.classList.contains('on'))return;
  th.style.display='none';
  fr.innerHTML='<iframe src="https://www.youtube.com/embed/'+id+'?autoplay=1&rel=0" allow="autoplay;encrypted-media" allowfullscreen></iframe>';
  fr.classList.add('on');
};

// ========== Info accordion ==========
window.togInfoAcc=function(btn){
  var item=btn.parentElement,body=item.querySelector('.info-acc__body'),isOpen=item.classList.contains('open');
  document.querySelectorAll('.info-acc__item').forEach(function(i){i.classList.remove('open');var b=i.querySelector('.info-acc__body');if(b)b.style.maxHeight=null});
  if(!isOpen){item.classList.add('open');if(body)body.style.maxHeight=body.scrollHeight+'px'}
};

// ========== FAQ ==========
window.togFaq=function(btn){
  var item=btn.parentElement,ans=item.querySelector('.faq-a'),isOpen=item.classList.contains('open');
  document.querySelectorAll('.faq-i').forEach(function(fi){fi.classList.remove('open');var a=fi.querySelector('.faq-a');if(a)a.style.maxHeight=null});
  if(!isOpen){item.classList.add('open');if(ans)ans.style.maxHeight=ans.scrollHeight+'px'}
};

// ========== Mobile menu ==========
var burger=document.getElementById('burger');
if(burger){
  burger.addEventListener('click',function(){
    this.classList.toggle('on');
    var mobMenu=document.getElementById('mobMenu');
    if(mobMenu) mobMenu.classList.toggle('open');
    document.body.style.overflow=this.classList.contains('on')?'hidden':'';
  });
}
window.closeMob=function(){
  var b=document.getElementById('burger');
  var m=document.getElementById('mobMenu');
  if(b) b.classList.remove('on');
  if(m) m.classList.remove('open');
  document.body.style.overflow='';
};

window.toggleMobSub=function(btn){
  btn.classList.toggle('open');
  var sub=btn.nextElementSibling;
  if(sub) sub.classList.toggle('open');
};

// ========== Audio player ==========
window.toggleAudio=function(){
  var a=document.getElementById('hornAudio'),btn=document.getElementById('audioPlayBtn'),
      ico=document.getElementById('audioPlayIco'),wave=document.getElementById('audioWave');
  if(!a||!btn||!ico||!wave) return;
  if(a.paused){
    a.play();
    btn.classList.add('playing');
    ico.innerHTML='<rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/>';
    wave.classList.add('active');
  } else {
    a.pause();
    btn.classList.remove('playing');
    ico.innerHTML='<polygon points="5 3 19 12 5 21 5 3"/>';
    wave.classList.remove('active');
  }
};

(function(){
  var a=document.getElementById('hornAudio');
  if(!a) return;
  a.addEventListener('timeupdate',function(){
    var m=Math.floor(a.currentTime/60),s=Math.floor(a.currentTime%60);
    var timeEl=document.getElementById('audioTime');
    if(timeEl) timeEl.textContent=m+':'+(s<10?'0':'')+s;
  });
  a.addEventListener('ended',function(){
    var playBtn=document.getElementById('audioPlayBtn');
    var playIco=document.getElementById('audioPlayIco');
    var waveEl=document.getElementById('audioWave');
    var timeEl=document.getElementById('audioTime');
    if(playBtn) playBtn.classList.remove('playing');
    if(playIco) playIco.innerHTML='<polygon points="5 3 19 12 5 21 5 3"/>';
    if(waveEl) waveEl.classList.remove('active');
    if(timeEl) timeEl.textContent='0:00';
  });
})();

// ========== Volume level auto-cycle ==========
(function(){
  var lvls=document.querySelectorAll('.excl-lvl');
  if(lvls.length===0) return;
  var idx=2;
  setInterval(function(){
    lvls.forEach(function(l){l.classList.remove('active')});
    idx=(idx+1)%3;
    if(lvls[idx]) lvls[idx].classList.add('active');
  },1000);
})();

// ========== Scroll reveal (moved to inline <head> script in theme.v7.liquid) ==========

/* Addon popup — handled by inline script in section */

// ========== Video demo popup ==========
// DEMO_VIDEOS, renderVideo, switchVideo, openVideoPopup, closeVideoPopup
// are now defined dynamically in v7-product-hero.liquid inline script
// using product.media data from Shopify (per-product videos)

// ========== User photos lightbox ==========
(function(){
  var lightbox=document.getElementById('upLightbox');
  var track=document.getElementById('upTrack');
  var dots=document.getElementById('upDots');
  var slider=document.getElementById('upSlider');
  if(!lightbox||!track||!dots||!slider) return;
  var cur=0, startX=0, startY=0, diff=0, diffY=0, dragging=false, totalSlides=0;

  // Make all gallery items clickable
  function initGallery(selector){
    var items=document.querySelectorAll(selector);
    items.forEach(function(item,i){
      item.style.cursor='pointer';
      item.addEventListener('click',function(){
        var srcs=Array.from(items).map(function(el){var img=el.querySelector('img');return img?img.src:''});
        openLightbox(srcs,i);
      });
    });
  }
  initGallery('.user-photos__item');
  initGallery('.faq-gallery__item');
  initGallery('.faq-gallery__thumb');

  var lbAnimating=false;

  function openLightbox(srcs,idx){
    track.innerHTML='';
    dots.innerHTML='';
    totalSlides=srcs.length;

    // Clone last + all + clone first for infinite
    var lastClone=document.createElement('div');
    lastClone.className='up-lightbox__slide clone';
    lastClone.innerHTML='<img src="'+srcs[srcs.length-1]+'" alt="">';
    track.appendChild(lastClone);

    srcs.forEach(function(src,i){
      var slide=document.createElement('div');
      slide.className='up-lightbox__slide';
      slide.innerHTML='<img src="'+src+'" alt="">';
      track.appendChild(slide);
      var dot=document.createElement('button');
      dot.className='up-lightbox__dot'+(i===idx?' active':'');
      dot.onclick=function(){goTo(i)};
      dots.appendChild(dot);
    });

    var firstClone=document.createElement('div');
    firstClone.className='up-lightbox__slide clone';
    firstClone.innerHTML='<img src="'+srcs[0]+'" alt="">';
    track.appendChild(firstClone);

    cur=idx;
    updateSlider(false);
    lightbox.classList.add('active');
    document.body.style.overflow='hidden';
    lbAnimating=false;
  }
  window.openUpLightbox=openLightbox;

  window.closeUpLightbox=function(){
    lightbox.classList.remove('active');
    document.body.style.overflow='';
    slider.style.transform='';
    slider.style.opacity='';
  };

  function goTo(i){
    if(lbAnimating)return;
    cur=i;
    updateSlider(true);
  }

  function updateSlider(animate){
    var offset=(cur+1)*100; // +1 for prepended clone
    track.style.transition=animate?'transform .3s ease':'none';
    track.style.transform='translateX(-'+offset+'%)';
    dots.querySelectorAll('.up-lightbox__dot').forEach(function(d,i){d.classList.toggle('active',i===((cur%totalSlides)+totalSlides)%totalSlides)});
    if(animate) lbAnimating=true;
  }

  track.addEventListener('transitionend',function(){
    lbAnimating=false;
    if(cur>=totalSlides){
      cur=0;
      track.style.transition='none';
      track.style.transform='translateX(-100%)';
    } else if(cur<0){
      cur=totalSlides-1;
      track.style.transition='none';
      track.style.transform='translateX(-'+totalSlides*100+'%)';
    }
  });

  // Touch swipe (horizontal = slide, vertical = close)
  slider.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;startY=e.touches[0].clientY;diff=0;diffY=0;dragging=true;track.style.transition='none';});
  slider.addEventListener('touchmove',function(e){
    if(!dragging)return;
    diff=e.touches[0].clientX-startX;
    diffY=e.touches[0].clientY-startY;
    if(Math.abs(diffY)>Math.abs(diff)){
      slider.style.transition='none';
      slider.style.transform='translateY('+diffY+'px)';
      slider.style.opacity=Math.max(0,1-Math.abs(diffY)/300);
    } else {
      slider.style.transform='';slider.style.opacity='';
      track.style.transform='translateX(calc(-'+cur*100+'% + '+diff+'px))';
    }
  });
  slider.addEventListener('touchend',function(){
    if(!dragging)return; dragging=false;
    if(Math.abs(diffY)>100&&Math.abs(diffY)>Math.abs(diff)){
      slider.style.transition='transform .2s,opacity .2s';
      slider.style.transform='translateY('+(diffY>0?'100%':'-100%')+')';
      slider.style.opacity='0';
      setTimeout(function(){closeUpLightbox()},200);
      return;
    }
    slider.style.transition='transform .2s,opacity .2s';
    slider.style.transform='';slider.style.opacity='';
    if(Math.abs(diff)>50){
      if(diff<0) cur++;
      else cur--;
    }
    updateSlider(true);
  });

  // Desktop arrow keys
  document.addEventListener('keydown',function(e){
    if(!lightbox.classList.contains('active'))return;
    if(e.key==='Escape') closeUpLightbox();
    if(e.key==='ArrowRight') goTo(cur+1);
    if(e.key==='ArrowLeft') goTo(cur-1);
  });

  var prevBtn=document.getElementById('upPrev');
  var nextBtn=document.getElementById('upNext');
  if(prevBtn) prevBtn.addEventListener('click',function(e){e.stopPropagation();goTo(cur-1);});
  if(nextBtn) nextBtn.addEventListener('click',function(e){e.stopPropagation();goTo(cur+1);});

  lightbox.addEventListener('click',function(e){if(e.target===lightbox||e.target.classList.contains('up-lightbox__slider')||e.target.classList.contains('up-lightbox__slide')||e.target.classList.contains('up-lightbox__track'))closeUpLightbox();});
})();

}); // end DOMContentLoaded
